module.exports = __webpack_public_path__ + "img/savings_energy.74d08bf1.svg";